import { A2matFiltersService } from './../a2mat-filters.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Filter } from '../filter.model';

@Component({
  selector: 'app-filter-list',
  templateUrl: './filter-list.component.html',
  styleUrls: ['./filter-list.component.scss']
})
export class FilterListComponent implements OnInit {
  @Input() filter: Filter;
  @Input() filterForm: UntypedFormGroup;
  @Output() filterChange = new EventEmitter<any>();
  public selection;
  constructor(
    private translateService: TranslateService,
    private filterService: A2matFiltersService
  ) { }

  ngOnInit(): void {
  }
  onSubmit(){
    if (this.filterForm.valid){
      this.selection = this.selection || this.filter.options[0];
      this.filterService.setSelection(this.filter, this.selection);
      this.filterChange.emit(this.filter);
    }
  }
}
